import httpClient from '../../client'

import apiRoutes from '../constants'

const deleteProposal = async ({id}) => {
  return await httpClient.delete(`${apiRoutes.GET_PROPOSALS}/${id}`)
}

export default deleteProposal
